import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "./AuthLayout";
import { useAuth } from "../context/AuthContext";
import { ROLE_HOME } from "../lib/api";
import { useT, localizeError } from "../components/home/i18n";

export default function Login() {
  const { login } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const c = t.auth.login;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(c.welcome);
      navigate(ROLE_HOME[user.role] || "/");
    } catch (err) {
      const msg = localizeError(err.response?.data?.detail, t);
      toast.error(msg);
      if (err.response?.status === 403 && /verif|bestät/i.test(msg)) {
        navigate(`/verify-email?email=${encodeURIComponent(email)}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout testid="login-page" title={c.title} subtitle={c.subtitle}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-medium text-[#5C5855]">{c.email}</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]" />
        </div>
        <div>
          <label className="text-xs font-medium text-[#5C5855]">{c.password}</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]" />
        </div>
        <button data-testid="login-submit" disabled={loading}
          className="w-full rounded-full bg-[#1F4A38] py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
          {loading ? c.submitting : c.submit}
        </button>
        <p className="text-center text-sm">
          <Link to="/forgot-password" data-testid="go-forgot-password" className="font-medium text-[#8a6f38] hover:text-[#6f5626]">{c.forgot}</Link>
        </p>
        <p className="text-center text-sm text-[#5C5855]">
          {c.newHere} <Link to="/register" data-testid="go-register" className="font-semibold text-[#1F4A38]">{c.create}</Link>
        </p>
      </form>
    </AuthLayout>
  );
}
